export interface StateDistrict {
  state: string;
  district: string;
}

export const stateDistrictData: StateDistrict[] = [
    {
      "state": "Andhra Pradesh",
      "district": "Alluri Sitharama Raju"
    },
    {
      "state": "Andhra Pradesh",
      "district": "Anakapalli"
    },
    {
      "state": "Andhra Pradesh",
      "district": "Ananthapuramu"
    },
    {
      "state": "Andhra Pradesh",
      "district": "Annamayya"
    },
    {
      "state": "Andhra Pradesh",
      "district": "Bapatla"
    },
    {
      "state": "Andhra Pradesh",
      "district": "Chittoor"
    },
    {
      "state": "Andhra Pradesh",
      "district": "Dr. B.R. Ambedkar Konaseema"
    },
    {
      "state": "Andhra Pradesh",
      "district": "East Godavari"
    },
    {
      "state": "Andhra Pradesh",
      "district": "Eluru"
    },
    {
      "state": "Andhra Pradesh",
      "district": "Guntur"
    },
    {
      "state": "Andhra Pradesh",
      "district": "Kakinada"
    },
    {
      "state": "Andhra Pradesh",
      "district": "Krishna"
    },
    {
      "state": "Andhra Pradesh",
      "district": "Kurnool"
    },
    {
      "state": "Andhra Pradesh",
      "district": "Nandyal"
    },
    {
      "state": "Andhra Pradesh",
      "district": "NTR"
    },
    {
      "state": "Andhra Pradesh",
      "district": "Palnadu"
    },
    {
      "state": "Andhra Pradesh",
      "district": "Parvathipuram Manyam"
    },
    {
      "state": "Andhra Pradesh",
      "district": "Prakasam"
    },
    {
      "state": "Andhra Pradesh",
      "district": "Srikakulam"
    },
    {
      "state": "Andhra Pradesh",
      "district": "Sri Potti Sriramulu Nellore"
    },
    {
      "state": "Andhra Pradesh",
      "district": "Sri Sathya Sai"
    },
    {
      "state": "Andhra Pradesh",
      "district": "Tirupati"
    },
    {
      "state": "Andhra Pradesh",
      "district": "Visakhapatnam"
    },
    {
      "state": "Andhra Pradesh",
      "district": "Vizianagaram"
    },
    {
      "state": "Andhra Pradesh",
      "district": "West Godavari"
    },
    {
      "state": "Andhra Pradesh",
      "district": "YSR"
    },
    {
      "state": "Arunachal Pradesh",
      "district": "Anjaw"
    },
    {
      "state": "Arunachal Pradesh",
      "district": "Changlang"
    },
    {
      "state": "Arunachal Pradesh",
      "district": "East Kameng"
    },
    {
      "state": "Arunachal Pradesh",
      "district": "East Siang"
    },
    {
      "state": "Arunachal Pradesh",
      "district": "Itanagar capital complex"
    },
    {
      "state": "Arunachal Pradesh",
      "district": "Kamle"
    },
    {
      "state": "Arunachal Pradesh",
      "district": "Kra Daadi"
    },
    {
      "state": "Arunachal Pradesh",
      "district": "Kurung Kumey"
    },
    {
      "state": "Arunachal Pradesh",
      "district": "Lepa Rada"
    },
    {
      "state": "Arunachal Pradesh",
      "district": "Lohit"
    },
    {
      "state": "Arunachal Pradesh",
      "district": "Longding"
    },
    {
      "state": "Arunachal Pradesh",
      "district": "Lower Dibang Valley"
    },
    {
      "state": "Arunachal Pradesh",
      "district": "Lower Siang"
    },
    {
      "state": "Arunachal Pradesh",
      "district": "Lower Subansiri"
    },
    {
      "state": "Arunachal Pradesh",
      "district": "Namsai"
    },
    {
      "state": "Arunachal Pradesh",
      "district": "Pakke-Kessang"
    },
    {
      "state": "Arunachal Pradesh",
      "district": "Papum Pare"
    },
    {
      "state": "Arunachal Pradesh",
      "district": "Shi Yomi"
    },
    {
      "state": "Arunachal Pradesh",
      "district": "Siang"
    },
    {
      "state": "Arunachal Pradesh",
      "district": "Tawang"
    },
    {
      "state": "Arunachal Pradesh",
      "district": "Tirap"
    },
    {
      "state": "Arunachal Pradesh",
      "district": "Upper Dibang Valley"
    },
    {
      "state": "Arunachal Pradesh",
      "district": "Upper Siang"
    },
    {
      "state": "Arunachal Pradesh",
      "district": "Upper Subansiri"
    },
    {
      "state": "Arunachal Pradesh",
      "district": "West Kameng"
    },
    {
      "state": "Arunachal Pradesh",
      "district": "West Siang"
    },
    {
      "state": "Assam",
      "district": "Baksa"
    },
    {
      "state": "Assam",
      "district": "Barpeta"
    },
    {
      "state": "Assam",
      "district": "Bongaigaon"
    },
    {
      "state": "Assam",
      "district": "Cachar"
    },
    {
      "state": "Assam",
      "district": "Charaideo"
    },
    {
      "state": "Assam",
      "district": "Chirang"
    },
    {
      "state": "Assam",
      "district": "Darrang"
    },
    {
      "state": "Assam",
      "district": "Dhemaji"
    },
    {
      "state": "Assam",
      "district": "Dhubri"
    },
    {
      "state": "Assam",
      "district": "Dibrugarh"
    },
    {
      "state": "Assam",
      "district": "Dima Hasao"
    },
    {
      "state": "Assam",
      "district": "Goalpara"
    },
    {
      "state": "Assam",
      "district": "Golaghat"
    },
    {
      "state": "Assam",
      "district": "Hailakandi"
    },
    {
      "state": "Assam",
      "district": "Jorhat"
    },
    {
      "state": "Assam",
      "district": "Kamrup"
    },
    {
      "state": "Assam",
      "district": "Kamrup Metropolitan"
    },
    {
      "state": "Assam",
      "district": "Karbi Anglong"
    },
    {
      "state": "Assam",
      "district": "Karimganj"
    },
    {
      "state": "Assam",
      "district": "Kokrajhar"
    },
    {
      "state": "Assam",
      "district": "Lakhimpur"
    },
    {
      "state": "Assam",
      "district": "Majuli"
    },
    {
      "state": "Assam",
      "district": "Morigaon"
    },
    {
      "state": "Assam",
      "district": "Nagaon"
    },
    {
      "state": "Assam",
      "district": "Nalbari"
    },
    {
      "state": "Assam",
      "district": "Sivasagar"
    },
    {
      "state": "Assam",
      "district": "Sonitpur"
    },
    {
      "state": "Assam",
      "district": "South Salmara Mankachar"
    },
    {
      "state": "Assam",
      "district": "Tinsukia"
    },
    {
      "state": "Assam",
      "district": "Udalguri"
    },
    {
      "state": "Assam",
      "district": "West Karbi Anglong"
    },
    {
      "state": "Bihar",
      "district": "Araria"
    },
    {
      "state": "Bihar",
      "district": "Arwal"
    },
    {
      "state": "Bihar",
      "district": "Aurangabad"
    },
    {
      "state": "Bihar",
      "district": "Banka"
    },
    {
      "state": "Bihar",
      "district": "Begusarai"
    },
    {
      "state": "Bihar",
      "district": "Bhagalpur"
    },
    {
      "state": "Bihar",
      "district": "Bhojpur"
    },
    {
      "state": "Bihar",
      "district": "Buxar"
    },
    {
      "state": "Bihar",
      "district": "Darbhanga"
    },
    {
      "state": "Bihar",
      "district": "East Champaran"
    },
    {
      "state": "Bihar",
      "district": "Gaya"
    },
    {
      "state": "Bihar",
      "district": "Gopalganj"
    },
    {
      "state": "Bihar",
      "district": "Jamui"
    },
    {
      "state": "Bihar",
      "district": "Jehanabad"
    },
    {
      "state": "Bihar",
      "district": "Kaimur"
    },
    {
      "state": "Bihar",
      "district": "Katihar"
    },
    {
      "state": "Bihar",
      "district": "Khagaria"
    },
    {
      "state": "Bihar",
      "district": "Kishanganj"
    },
    {
      "state": "Bihar",
      "district": "Lakhisarai"
    },
    {
      "state": "Bihar",
      "district": "Madhepura"
    },
    {
      "state": "Bihar",
      "district": "Madhubani"
    },
    {
      "state": "Bihar",
      "district": "Munger"
    },
    {
      "state": "Bihar",
      "district": "Muzaffarpur"
    },
    {
      "state": "Bihar",
      "district": "Nalanda"
    },
    {
      "state": "Bihar",
      "district": "Nawada"
    },
    {
      "state": "Bihar",
      "district": "Patna"
    },
    {
      "state": "Bihar",
      "district": "Purnia"
    },
    {
      "state": "Bihar",
      "district": "Rohtas"
    },
    {
      "state": "Bihar",
      "district": "Saharsa"
    },
    {
      "state": "Bihar",
      "district": "Samastipur"
    },
    {
      "state": "Bihar",
      "district": "Saran"
    },
    {
      "state": "Bihar",
      "district": "Sheikhpura"
    },
    {
      "state": "Bihar",
      "district": "Sheohar"
    },
    {
      "state": "Bihar",
      "district": "Sitamarhi"
    },
    {
      "state": "Bihar",
      "district": "Siwan"
    },
    {
      "state": "Bihar",
      "district": "Supaul"
    },
    {
      "state": "Bihar",
      "district": "Vaishali"
    },
    {
      "state": "Bihar",
      "district": "West Champaran"
    },
    {
      "state": "Chhattisgarh",
      "district": "Balod"
    },
    {
      "state": "Chhattisgarh",
      "district": "Baloda Bazar"
    },
    {
      "state": "Chhattisgarh",
      "district": "Balrampur-Ramanujganj"
    },
    {
      "state": "Chhattisgarh",
      "district": "Bastar"
    },
    {
      "state": "Chhattisgarh",
      "district": "Bemetara"
    },
    {
      "state": "Chhattisgarh",
      "district": "Bijapur"
    },
    {
      "state": "Chhattisgarh",
      "district": "Bilaspur"
    },
    {
      "state": "Chhattisgarh",
      "district": "Dantewada"
    },
    {
      "state": "Chhattisgarh",
      "district": "Dhamtari"
    },
    {
      "state": "Chhattisgarh",
      "district": "Durg"
    },
    {
      "state": "Chhattisgarh",
      "district": "Gariaband"
    },
    {
      "state": "Chhattisgarh",
      "district": "Gaurela-Pendra-Marwahi"
    },
    {
      "state": "Chhattisgarh",
      "district": "Janjgir-Champa"
    },
    {
      "state": "Chhattisgarh",
      "district": "Jashpur"
    },
    {
      "state": "Chhattisgarh",
      "district": "Kabirdham"
    },
    {
      "state": "Chhattisgarh",
      "district": "Kanker"
    },
    {
      "state": "Chhattisgarh",
      "district": "Khairagarh-Chhuikhadan-Gandai"
    },
    {
      "state": "Chhattisgarh",
      "district": "Kondagaon"
    },
    {
      "state": "Chhattisgarh",
      "district": "Korba"
    },
    {
      "state": "Chhattisgarh",
      "district": "Korea"
    },
    {
      "state": "Chhattisgarh",
      "district": "Mahasamund"
    },
    {
      "state": "Chhattisgarh",
      "district": "Manendragarh-Chirmiri-Bharatpur"
    },
    {
      "state": "Chhattisgarh",
      "district": "Mohla-Manpur-Ambagarh Chowki"
    },
    {
      "state": "Chhattisgarh",
      "district": "Mungeli"
    },
    {
      "state": "Chhattisgarh",
      "district": "Narayanpur"
    },
    {
      "state": "Chhattisgarh",
      "district": "Raigarh"
    },
    {
      "state": "Chhattisgarh",
      "district": "Raipur"
    },
    {
      "state": "Chhattisgarh",
      "district": "Rajnandgaon"
    },
    {
      "state": "Chhattisgarh",
      "district": "Sarangarh-Bilaigarh"
    },
    {
      "state": "Chhattisgarh",
      "district": "Shakti"
    },
    {
      "state": "Chhattisgarh",
      "district": "Sukma"
    },
    {
      "state": "Chhattisgarh",
      "district": "Surajpur"
    },
    {
      "state": "Chhattisgarh",
      "district": "Surguja"
    },
    {
      "state": "Delhi",
      "district": "Central Delhi"
    },
    {
      "state": "Delhi",
      "district": "East Delhi"
    },
    {
      "state": "Delhi",
      "district": "New Delhi"
    },
    {
      "state": "Delhi",
      "district": "North Delhi"
    },
    {
      "state": "Delhi",
      "district": "North East Delhi"
    },
    {
      "state": "Delhi",
      "district": "North West Delhi"
    },
    {
      "state": "Delhi",
      "district": "Shahdara district"
    },
    {
      "state": "Delhi",
      "district": "South Delhi"
    },
    {
      "state": "Delhi",
      "district": "South East Delhi"
    },
    {
      "state": "Delhi",
      "district": "South West Delhi"
    },
    {
      "state": "Delhi",
      "district": "West Delhi"
    },
    {
      "state": "Goa",
      "district": "North Goa"
    },
    {
      "state": "Goa",
      "district": "South Goa"
    },
    {
      "state": "Gujarat",
      "district": "Ahmedabad"
    },
    {
      "state": "Gujarat",
      "district": "Amreli"
    },
    {
      "state": "Gujarat",
      "district": "Anand"
    },
    {
      "state": "Gujarat",
      "district": "Aravalli"
    },
    {
      "state": "Gujarat",
      "district": "Banaskantha"
    },
    {
      "state": "Gujarat",
      "district": "Bharuch"
    },
    {
      "state": "Gujarat",
      "district": "Bhavnagar"
    },
    {
      "state": "Gujarat",
      "district": "Botad"
    },
    {
      "state": "Gujarat",
      "district": "Chhota Udaipur"
    },
    {
      "state": "Gujarat",
      "district": "Dahod"
    },
    {
      "state": "Gujarat",
      "district": "Dang"
    },
    {
      "state": "Gujarat",
      "district": "Devbhumi Dwarka"
    },
    {
      "state": "Gujarat",
      "district": "Gandhinagar"
    },
    {
      "state": "Gujarat",
      "district": "Gir Somnath"
    },
    {
      "state": "Gujarat",
      "district": "Jamnagar"
    },
    {
      "state": "Gujarat",
      "district": "Junagadh"
    },
    {
      "state": "Gujarat",
      "district": "Kheda"
    },
    {
      "state": "Gujarat",
      "district": "Kutch"
    },
    {
      "state": "Gujarat",
      "district": "Mahisagar"
    },
    {
      "state": "Gujarat",
      "district": "Mehsana"
    },
    {
      "state": "Gujarat",
      "district": "Morbi"
    },
    {
      "state": "Gujarat",
      "district": "Narmada"
    },
    {
      "state": "Gujarat",
      "district": "Navsari"
    },
    {
      "state": "Gujarat",
      "district": "Panchmahal"
    },
    {
      "state": "Gujarat",
      "district": "Patan"
    },
    {
      "state": "Gujarat",
      "district": "Porbandar"
    },
    {
      "state": "Gujarat",
      "district": "Rajkot"
    },
    {
      "state": "Gujarat",
      "district": "Sabarkantha"
    },
    {
      "state": "Gujarat",
      "district": "Surat"
    },
    {
      "state": "Gujarat",
      "district": "Surendranagar"
    },
    {
      "state": "Gujarat",
      "district": "Tapi"
    },
    {
      "state": "Gujarat",
      "district": "Vadodara"
    },
    {
      "state": "Gujarat",
      "district": "Valsad"
    },
    {
      "state": "Haryana",
      "district": "Ambala"
    },
    {
      "state": "Haryana",
      "district": "Bhiwani"
    },
    {
      "state": "Haryana",
      "district": "Charkhi Dadri"
    },
    {
      "state": "Haryana",
      "district": "Faridabad"
    },
    {
      "state": "Haryana",
      "district": "Fatehabad"
    },
    {
      "state": "Haryana",
      "district": "Gurugram"
    },
    {
      "state": "Haryana",
      "district": "Hisar"
    },
    {
      "state": "Haryana",
      "district": "Jhajjar"
    },
    {
      "state": "Haryana",
      "district": "Jind"
    },
    {
      "state": "Haryana",
      "district": "Kaithal"
    },
    {
      "state": "Haryana",
      "district": "Karnal"
    },
    {
      "state": "Haryana",
      "district": "Kurukshetra"
    },
    {
      "state": "Haryana",
      "district": "Mahendragarh"
    },
    {
      "state": "Haryana",
      "district": "Nuh"
    },
    {
      "state": "Haryana",
      "district": "Palwal"
    },
    {
      "state": "Haryana",
      "district": "Panchkula"
    },
    {
      "state": "Haryana",
      "district": "Panipat"
    },
    {
      "state": "Haryana",
      "district": "Rewari"
    },
    {
      "state": "Haryana",
      "district": "Rohtak"
    },
    {
      "state": "Haryana",
      "district": "Sirsa"
    },
    {
      "state": "Haryana",
      "district": "Sonipat"
    },
    {
      "state": "Haryana",
      "district": "Yamunanagar"
    },
    {
      "state": "Himachal Pradesh",
      "district": "Bilaspur"
    },
    {
      "state": "Himachal Pradesh",
      "district": "Chamba"
    },
    {
      "state": "Himachal Pradesh",
      "district": "Hamirpur"
    },
    {
      "state": "Himachal Pradesh",
      "district": "Kangra"
    },
    {
      "state": "Himachal Pradesh",
      "district": "Kinnaur"
    },
    {
      "state": "Himachal Pradesh",
      "district": "Kullu"
    },
    {
      "state": "Himachal Pradesh",
      "district": "Lahaul and Spiti"
    },
    {
      "state": "Himachal Pradesh",
      "district": "Mandi"
    },
    {
      "state": "Himachal Pradesh",
      "district": "Shimla"
    },
    {
      "state": "Himachal Pradesh",
      "district": "Sirmaur"
    },
    {
      "state": "Himachal Pradesh",
      "district": "Solan"
    },
    {
      "state": "Himachal Pradesh",
      "district": "Una"
    },
    {
      "state": "Jharkhand",
      "district": "Bokaro"
    },
    {
      "state": "Jharkhand",
      "district": "Chatra"
    },
    {
      "state": "Jharkhand",
      "district": "Deoghar"
    },
    {
      "state": "Jharkhand",
      "district": "Dhanbad"
    },
    {
      "state": "Jharkhand",
      "district": "Dumka"
    },
    {
      "state": "Jharkhand",
      "district": "East Singhbhum"
    },
    {
      "state": "Jharkhand",
      "district": "Garhwa"
    },
    {
      "state": "Jharkhand",
      "district": "Giridih"
    },
    {
      "state": "Jharkhand",
      "district": "Godda"
    },
    {
      "state": "Jharkhand",
      "district": "Gumla"
    },
    {
      "state": "Jharkhand",
      "district": "Hazaribag"
    },
    {
      "state": "Jharkhand",
      "district": "Jamtara"
    },
    {
      "state": "Jharkhand",
      "district": "Khunti"
    },
    {
      "state": "Jharkhand",
      "district": "Koderma"
    },
    {
      "state": "Jharkhand",
      "district": "Latehar"
    },
    {
      "state": "Jharkhand",
      "district": "Lohardaga"
    },
    {
      "state": "Jharkhand",
      "district": "Pakur"
    },
    {
      "state": "Jharkhand",
      "district": "Palamu"
    },
    {
      "state": "Jharkhand",
      "district": "Ramgarh"
    },
    {
      "state": "Jharkhand",
      "district": "Ranchi"
    },
    {
      "state": "Jharkhand",
      "district": "Sahibganj"
    },
    {
      "state": "Jharkhand",
      "district": "Seraikela-Kharsawan"
    },
    {
      "state": "Jharkhand",
      "district": "Simdega"
    },
    {
      "state": "Jharkhand",
      "district": "West Singhbhum"
    },
    {
      "state": "Karnataka",
      "district": "Bagalakote"
    },
    {
      "state": "Karnataka",
      "district": "Ballari"
    },
    {
      "state": "Karnataka",
      "district": "Belagavi"
    },
    {
      "state": "Karnataka",
      "district": "Bengaluru Rural"
    },
    {
      "state": "Karnataka",
      "district": "Bengaluru Urban"
    },
    {
      "state": "Karnataka",
      "district": "Bidar"
    },
    {
      "state": "Karnataka",
      "district": "Chamarajanagara"
    },
    {
      "state": "Karnataka",
      "district": "Chikkaballapura"
    },
    {
      "state": "Karnataka",
      "district": "Chikkamagaluru"
    },
    {
      "state": "Karnataka",
      "district": "Chitradurga"
    },
    {
      "state": "Karnataka",
      "district": "Dakshina Kannada"
    },
    {
      "state": "Karnataka",
      "district": "Davanagere"
    },
    {
      "state": "Karnataka",
      "district": "Dharwada"
    },
    {
      "state": "Karnataka",
      "district": "Gadaga"
    },
    {
      "state": "Karnataka",
      "district": "Kalaburagi"
    },
    {
      "state": "Karnataka",
      "district": "Hassan"
    },
    {
      "state": "Karnataka",
      "district": "Haveri"
    },
    {
      "state": "Karnataka",
      "district": "Kodagu"
    },
    {
      "state": "Karnataka",
      "district": "Kolar"
    },
    {
      "state": "Karnataka",
      "district": "Koppala"
    },
    {
      "state": "Karnataka",
      "district": "Mandya"
    },
    {
      "state": "Karnataka",
      "district": "Mysuru"
    },
    {
      "state": "Karnataka",
      "district": "Raichuru"
    },
    {
      "state": "Karnataka",
      "district": "Ramanagara"
    },
    {
      "state": "Karnataka",
      "district": "Shivamogga"
    },
    {
      "state": "Karnataka",
      "district": "Tumakuru"
    },
    {
      "state": "Karnataka",
      "district": "Udupi"
    },
    {
      "state": "Karnataka",
      "district": "Uttara Kannada"
    },
    {
      "state": "Karnataka",
      "district": "Vijayanagara"
    },
    {
      "state": "Karnataka",
      "district": "Vijayapura"
    },
    {
      "state": "Karnataka",
      "district": "Yadgiri"
    },
    {
      "state": "Kerala",
      "district": "Alappuzha"
    },
    {
      "state": "Kerala",
      "district": "Ernakulam"
    },
    {
      "state": "Kerala",
      "district": "Idukki"
    },
    {
      "state": "Kerala",
      "district": "Kannur"
    },
    {
      "state": "Kerala",
      "district": "Kasaragod"
    },
    {
      "state": "Kerala",
      "district": "Kollam"
    },
    {
      "state": "Kerala",
      "district": "Kottayam"
    },
    {
      "state": "Kerala",
      "district": "Kozhikode"
    },
    {
      "state": "Kerala",
      "district": "Malappuram"
    },
    {
      "state": "Kerala",
      "district": "Palakkad"
    },
    {
      "state": "Kerala",
      "district": "Pathanamthitta"
    },
    {
      "state": "Kerala",
      "district": "Thiruvananthapuram"
    },
    {
      "state": "Kerala",
      "district": "Thrissur"
    },
    {
      "state": "Kerala",
      "district": "Wayanad"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Agar Malwa"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Alirajpur"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Anuppur"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Ashoknagar"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Balaghat"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Barwani"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Betul"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Bhind"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Bhopal"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Burhanpur"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Chhatarpur"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Chhindwara"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Damoh"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Datia"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Dewas"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Dhar"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Dindori"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Guna"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Gwalior"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Harda"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Hoshangabad"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Indore"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Jabalpur"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Jhabua"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Katni"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Khandwa"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Khargone"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Mandla"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Mandsaur"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Morena"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Narsinghpur"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Neemuch"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Niwari"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Panna"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Raisen"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Rajgarh"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Ratlam"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Rewa"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Sagar"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Satna"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Sehore"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Seoni"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Shahdol"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Shajapur"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Sheopur"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Shivpuri"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Sidhi"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Singrauli"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Tikamgarh"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Ujjain"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Umaria"
    },
    {
      "state": "Madhya Pradesh",
      "district": "Vidisha"
    },
    {
      "state": "Maharashtra",
      "district": "Ahmednagar"
    },
    {
      "state": "Maharashtra",
      "district": "Akola"
    },
    {
      "state": "Maharashtra",
      "district": "Amravati"
    },
    {
      "state": "Maharashtra",
      "district": "Beed"
    },
    {
      "state": "Maharashtra",
      "district": "Bhandara"
    },
    {
      "state": "Maharashtra",
      "district": "Buldhana"
    },
    {
      "state": "Maharashtra",
      "district": "Chandrapur"
    },
    {
      "state": "Maharashtra",
      "district": "Osmanabad"
    },
    {
      "state": "Maharashtra",
      "district": "Dhule"
    },
    {
      "state": "Maharashtra",
      "district": "Gadchiroli"
    },
    {
      "state": "Maharashtra",
      "district": "Gondia"
    },
    {
      "state": "Maharashtra",
      "district": "Hingoli"
    },
    {
      "state": "Maharashtra",
      "district": "Jalgaon"
    },
    {
      "state": "Maharashtra",
      "district": "Jalna"
    },
    {
      "state": "Maharashtra",
      "district": "Kolhapur"
    },
    {
      "state": "Maharashtra",
      "district": "Latur"
    },
    {
      "state": "Maharashtra",
      "district": "Mumbai City"
    },
    {
      "state": "Maharashtra",
      "district": "Mumbai Suburban"
    },
    {
      "state": "Maharashtra",
      "district": "Nanded"
    },
    {
      "state": "Maharashtra",
      "district": "Nandurbar"
    },
    {
      "state": "Maharashtra",
      "district": "Nagpur"
    },
    {
      "state": "Maharashtra",
      "district": "Nashik"
    },
    {
      "state": "Maharashtra",
      "district": "Palghar"
    },
    {
      "state": "Maharashtra",
      "district": "Parbhani"
    },
    {
      "state": "Maharashtra",
      "district": "Pune"
    },
    {
      "state": "Maharashtra",
      "district": "Raigad"
    },
    {
      "state": "Maharashtra",
      "district": "Ratnagiri"
    },
    {
      "state": "Maharashtra",
      "district": "Aurangabad"
    },
    {
      "state": "Maharashtra",
      "district": "Sangli"
    },
    {
      "state": "Maharashtra",
      "district": "Satara"
    },
    {
      "state": "Maharashtra",
      "district": "Sindhudurg"
    },
    {
      "state": "Maharashtra",
      "district": "Solapur"
    },
    {
      "state": "Maharashtra",
      "district": "Thane"
    },
    {
      "state": "Maharashtra",
      "district": "Wardha"
    },
    {
      "state": "Maharashtra",
      "district": "Washim"
    },
    {
      "state": "Maharashtra",
      "district": "Yavatmal"
    },
    {
      "state": "Manipur",
      "district": "Bishnupur"
    },
    {
      "state": "Manipur",
      "district": "Chandel"
    },
    {
      "state": "Manipur",
      "district": "Churachandpur"
    },
    {
      "state": "Manipur",
      "district": "Imphal East"
    },
    {
      "state": "Manipur",
      "district": "Imphal West"
    },
    {
      "state": "Manipur",
      "district": "Jiribam"
    },
    {
      "state": "Manipur",
      "district": "Kakching"
    },
    {
      "state": "Manipur",
      "district": "Kamjong"
    },
    {
      "state": "Manipur",
      "district": "Kangpokpi"
    },
    {
      "state": "Manipur",
      "district": "Noney"
    },
    {
      "state": "Manipur",
      "district": "Pherzawl"
    },
    {
      "state": "Manipur",
      "district": "Senapati"
    },
    {
      "state": "Manipur",
      "district": "Tamenglong"
    },
    {
      "state": "Manipur",
      "district": "Tengnoupal"
    },
    {
      "state": "Manipur",
      "district": "Thoubal"
    },
    {
      "state": "Manipur",
      "district": "Ukhrul"
    },
    {
      "state": "Meghalaya",
      "district": "East Garo Hills"
    },
    {
      "state": "Meghalaya",
      "district": "East Khasi Hills"
    },
    {
      "state": "Meghalaya",
      "district": "East Jaintia Hills"
    },
    {
      "state": "Meghalaya",
      "district": "Eastern West Khasi Hills"
    },
    {
      "state": "Meghalaya",
      "district": "North Garo Hills"
    },
    {
      "state": "Meghalaya",
      "district": "Ri Bhoi"
    },
    {
      "state": "Meghalaya",
      "district": "South Garo Hills"
    },
    {
      "state": "Meghalaya",
      "district": "South West Garo Hills"
    },
    {
      "state": "Meghalaya",
      "district": "South West Khasi Hills"
    },
    {
      "state": "Meghalaya",
      "district": "West Garo Hills"
    },
    {
      "state": "Meghalaya",
      "district": "West Jaintia Hills"
    },
    {
      "state": "Meghalaya",
      "district": "West Khasi Hills"
    },
    {
      "state": "Mizoram",
      "district": "Aizawl"
    },
    {
      "state": "Mizoram",
      "district": "Champhai"
    },
    {
      "state": "Mizoram",
      "district": "Hnahthial"
    },
    {
      "state": "Mizoram",
      "district": "Khawzawl"
    },
    {
      "state": "Mizoram",
      "district": "Kolasib"
    },
    {
      "state": "Mizoram",
      "district": "Lawngtlai"
    },
    {
      "state": "Mizoram",
      "district": "Lunglei"
    },
    {
      "state": "Mizoram",
      "district": "Mamit"
    },
    {
      "state": "Mizoram",
      "district": "Saiha"
    },
    {
      "state": "Mizoram",
      "district": "Saitual"
    },
    {
      "state": "Mizoram",
      "district": "Serchhip"
    },
    {
      "state": "Nagaland",
      "district": "Chümoukedima"
    },
    {
      "state": "Nagaland",
      "district": "Dimapur"
    },
    {
      "state": "Nagaland",
      "district": "Kiphire"
    },
    {
      "state": "Nagaland",
      "district": "Kohima"
    },
    {
      "state": "Nagaland",
      "district": "Longleng"
    },
    {
      "state": "Nagaland",
      "district": "Mokokchung"
    },
    {
      "state": "Nagaland",
      "district": "Mon"
    },
    {
      "state": "Nagaland",
      "district": "Niuland"
    },
    {
      "state": "Nagaland",
      "district": "Noklak"
    },
    {
      "state": "Nagaland",
      "district": "Peren"
    },
    {
      "state": "Nagaland",
      "district": "Phek"
    },
    {
      "state": "Nagaland",
      "district": "Shamator"
    },
    {
      "state": "Nagaland",
      "district": "Tseminyü"
    },
    {
      "state": "Nagaland",
      "district": "Tuensang"
    },
    {
      "state": "Nagaland",
      "district": "Wokha"
    },
    {
      "state": "Nagaland",
      "district": "Zunheboto"
    },
    {
      "state": "Odisha",
      "district": "Angul"
    },
    {
      "state": "Odisha",
      "district": "Boudh"
    },
    {
      "state": "Odisha",
      "district": "Bhadrak"
    },
    {
      "state": "Odisha",
      "district": "Balangir"
    },
    {
      "state": "Odisha",
      "district": "Bargarh"
    },
    {
      "state": "Odisha",
      "district": "Balasore"
    },
    {
      "state": "Odisha",
      "district": "Cuttack"
    },
    {
      "state": "Odisha",
      "district": "Debagarh"
    },
    {
      "state": "Odisha",
      "district": "Dhenkanal"
    },
    {
      "state": "Odisha",
      "district": "Ganjam"
    },
    {
      "state": "Odisha",
      "district": "Gajapati"
    },
    {
      "state": "Odisha",
      "district": "Jharsuguda"
    },
    {
      "state": "Odisha",
      "district": "Jajpur"
    },
    {
      "state": "Odisha",
      "district": "Jagatsinghpur"
    },
    {
      "state": "Odisha",
      "district": "Khordha"
    },
    {
      "state": "Odisha",
      "district": "Kendujhar"
    },
    {
      "state": "Odisha",
      "district": "Kalahandi"
    },
    {
      "state": "Odisha",
      "district": "Kandhamal"
    },
    {
      "state": "Odisha",
      "district": "Koraput"
    },
    {
      "state": "Odisha",
      "district": "Kendrapara"
    },
    {
      "state": "Odisha",
      "district": "Malkangiri"
    },
    {
      "state": "Odisha",
      "district": "Mayurbhanj"
    },
    {
      "state": "Odisha",
      "district": "Nabarangpur"
    },
    {
      "state": "Odisha",
      "district": "Nuapada"
    },
    {
      "state": "Odisha",
      "district": "Nayagarh"
    },
    {
      "state": "Odisha",
      "district": "Puri"
    },
    {
      "state": "Odisha",
      "district": "Rayagada"
    },
    {
      "state": "Odisha",
      "district": "Sambalpur"
    },
    {
      "state": "Odisha",
      "district": "Subarnapur"
    },
    {
      "state": "Odisha",
      "district": "Sundargarh"
    },
    {
      "state": "Punjab",
      "district": "Amritsar"
    },
    {
      "state": "Punjab",
      "district": "Barnala"
    },
    {
      "state": "Punjab",
      "district": "Bathinda"
    },
    {
      "state": "Punjab",
      "district": "Firozpur"
    },
    {
      "state": "Punjab",
      "district": "Faridkot"
    },
    {
      "state": "Punjab",
      "district": "Fatehgarh Sahib"
    },
    {
      "state": "Punjab",
      "district": "Fazilka"
    },
    {
      "state": "Punjab",
      "district": "Gurdaspur"
    },
    {
      "state": "Punjab",
      "district": "Hoshiarpur"
    },
    {
      "state": "Punjab",
      "district": "Jalandhar"
    },
    {
      "state": "Punjab",
      "district": "Kapurthala"
    },
    {
      "state": "Punjab",
      "district": "Ludhiana"
    },
    {
      "state": "Punjab",
      "district": "Malerkotla"
    },
    {
      "state": "Punjab",
      "district": "Mansa"
    },
    {
      "state": "Punjab",
      "district": "Moga"
    },
    {
      "state": "Punjab",
      "district": "Sri Muktsar Sahib"
    },
    {
      "state": "Punjab",
      "district": "Pathankot"
    },
    {
      "state": "Punjab",
      "district": "Patiala"
    },
    {
      "state": "Punjab",
      "district": "Rupnagar"
    },
    {
      "state": "Punjab",
      "district": "Sahibzada Ajit Singh Nagar"
    },
    {
      "state": "Punjab",
      "district": "Sangrur"
    },
    {
      "state": "Punjab",
      "district": "Shahid Bhagat Singh Nagar"
    },
    {
      "state": "Punjab",
      "district": "Tarn Taran"
    },
    {
      "state": "Rajasthan",
      "district": "Ajmer"
    },
    {
      "state": "Rajasthan",
      "district": "Alwar"
    },
    {
      "state": "Rajasthan",
      "district": "Bikaner"
    },
    {
      "state": "Rajasthan",
      "district": "Barmer"
    },
    {
      "state": "Rajasthan",
      "district": "Banswara"
    },
    {
      "state": "Rajasthan",
      "district": "Bharatpur"
    },
    {
      "state": "Rajasthan",
      "district": "Baran"
    },
    {
      "state": "Rajasthan",
      "district": "Bundi"
    },
    {
      "state": "Rajasthan",
      "district": "Bhilwara"
    },
    {
      "state": "Rajasthan",
      "district": "Churu"
    },
    {
      "state": "Rajasthan",
      "district": "Chittorgarh"
    },
    {
      "state": "Rajasthan",
      "district": "Dausa"
    },
    {
      "state": "Rajasthan",
      "district": "Dholpur"
    },
    {
      "state": "Rajasthan",
      "district": "Dungarpur"
    },
    {
      "state": "Rajasthan",
      "district": "Sri Ganganagar"
    },
    {
      "state": "Rajasthan",
      "district": "Hanumangarh"
    },
    {
      "state": "Rajasthan",
      "district": "Jhunjhunu"
    },
    {
      "state": "Rajasthan",
      "district": "Jalore"
    },
    {
      "state": "Rajasthan",
      "district": "Jodhpur"
    },
    {
      "state": "Rajasthan",
      "district": "Jaipur"
    },
    {
      "state": "Rajasthan",
      "district": "Jaisalmer"
    },
    {
      "state": "Rajasthan",
      "district": "Jhalawar"
    },
    {
      "state": "Rajasthan",
      "district": "Karauli"
    },
    {
      "state": "Rajasthan",
      "district": "Kota"
    },
    {
      "state": "Rajasthan",
      "district": "Nagaur"
    },
    {
      "state": "Rajasthan",
      "district": "Pali"
    },
    {
      "state": "Rajasthan",
      "district": "Pratapgarh"
    },
    {
      "state": "Rajasthan",
      "district": "Rajsamand"
    },
    {
      "state": "Rajasthan",
      "district": "Sikar"
    },
    {
      "state": "Rajasthan",
      "district": "Sawai Madhopur"
    },
    {
      "state": "Rajasthan",
      "district": "Sirohi"
    },
    {
      "state": "Rajasthan",
      "district": "Tonk"
    },
    {
      "state": "Rajasthan",
      "district": "Udaipur"
    },
    {
      "state": "Sikkim",
      "district": "East Sikkim"
    },
    {
      "state": "Sikkim",
      "district": "North Sikkim"
    },
    {
      "state": "Sikkim",
      "district": "Pakyong"
    },
    {
      "state": "Sikkim",
      "district": "Soreng"
    },
    {
      "state": "Sikkim",
      "district": "South Sikkim"
    },
    {
      "state": "Sikkim",
      "district": "West Sikkim"
    },
    {
      "state": "Tamil Nadu",
      "district": "Ariyalur"
    },
    {
      "state": "Tamil Nadu",
      "district": "Chengalpattu"
    },
    {
      "state": "Tamil Nadu",
      "district": "Chennai"
    },
    {
      "state": "Tamil Nadu",
      "district": "Coimbatore"
    },
    {
      "state": "Tamil Nadu",
      "district": "Cuddalore"
    },
    {
      "state": "Tamil Nadu",
      "district": "Dharmapuri"
    },
    {
      "state": "Tamil Nadu",
      "district": "Dindigul"
    },
    {
      "state": "Tamil Nadu",
      "district": "Erode"
    },
    {
      "state": "Tamil Nadu",
      "district": "Kallakurichi"
    },
    {
      "state": "Tamil Nadu",
      "district": "Kanchipuram"
    },
    {
      "state": "Tamil Nadu",
      "district": "Kanyakumari"
    },
    {
      "state": "Tamil Nadu",
      "district": "Karur"
    },
    {
      "state": "Tamil Nadu",
      "district": "Krishnagiri"
    },
    {
      "state": "Tamil Nadu",
      "district": "Madurai"
    },
    {
      "state": "Tamil Nadu",
      "district": "Mayiladuthurai"
    },
    {
      "state": "Tamil Nadu",
      "district": "Nagapattinam"
    },
    {
      "state": "Tamil Nadu",
      "district": "Nilgiris"
    },
    {
      "state": "Tamil Nadu",
      "district": "Namakkal"
    },
    {
      "state": "Tamil Nadu",
      "district": "Perambalur"
    },
    {
      "state": "Tamil Nadu",
      "district": "Pudukkottai"
    },
    {
      "state": "Tamil Nadu",
      "district": "Ramanathapuram"
    },
    {
      "state": "Tamil Nadu",
      "district": "Ranipet"
    },
    {
      "state": "Tamil Nadu",
      "district": "Salem"
    },
    {
      "state": "Tamil Nadu",
      "district": "Sivaganga"
    },
    {
      "state": "Tamil Nadu",
      "district": "Tenkasi"
    },
    {
      "state": "Tamil Nadu",
      "district": "Tiruppur"
    },
    {
      "state": "Tamil Nadu",
      "district": "Tiruchirappalli"
    },
    {
      "state": "Tamil Nadu",
      "district": "Theni"
    },
    {
      "state": "Tamil Nadu",
      "district": "Tirunelveli"
    },
    {
      "state": "Tamil Nadu",
      "district": "Thanjavur"
    },
    {
      "state": "Tamil Nadu",
      "district": "Thoothukudi"
    },
    {
      "state": "Tamil Nadu",
      "district": "Tirupattur"
    },
    {
      "state": "Tamil Nadu",
      "district": "Tiruvallur"
    },
    {
      "state": "Tamil Nadu",
      "district": "Tiruvarur"
    },
    {
      "state": "Tamil Nadu",
      "district": "Tiruvannamalai"
    },
    {
      "state": "Tamil Nadu",
      "district": "Vellore"
    },
    {
      "state": "Tamil Nadu",
      "district": "Viluppuram"
    },
    {
      "state": "Tamil Nadu",
      "district": "Virudhunagar"
    },
    {
      "state": "Telangana",
      "district": "Adilabad"
    },
    {
      "state": "Telangana",
      "district": "Bhadradri Kothagudem"
    },
    {
      "state": "Telangana",
      "district": "Hanamkonda"
    },
    {
      "state": "Telangana",
      "district": "Hyderabad"
    },
    {
      "state": "Telangana",
      "district": "Jagtial"
    },
    {
      "state": "Telangana",
      "district": "Jangaon"
    },
    {
      "state": "Telangana",
      "district": "Jayashankar Bhupalpally"
    },
    {
      "state": "Telangana",
      "district": "Jogulamba Gadwal"
    },
    {
      "state": "Telangana",
      "district": "Kamareddy"
    },
    {
      "state": "Telangana",
      "district": "Karimnagar"
    },
    {
      "state": "Telangana",
      "district": "Khammam"
    },
    {
      "state": "Telangana",
      "district": "Kumuram Bheem Asifabad"
    },
    {
      "state": "Telangana",
      "district": "Mahabubabad"
    },
    {
      "state": "Telangana",
      "district": "Mahbubnagar"
    },
    {
      "state": "Telangana",
      "district": "Mancherial"
    },
    {
      "state": "Telangana",
      "district": "Medak"
    },
    {
      "state": "Telangana",
      "district": "Medchal–Malkajgiri"
    },
    {
      "state": "Telangana",
      "district": "Mulugu"
    },
    {
      "state": "Telangana",
      "district": "Nalgonda"
    },
    {
      "state": "Telangana",
      "district": "Narayanpet"
    },
    {
      "state": "Telangana",
      "district": "Nagarkurnool"
    },
    {
      "state": "Telangana",
      "district": "Nirmal"
    },
    {
      "state": "Telangana",
      "district": "Nizamabad"
    },
    {
      "state": "Telangana",
      "district": "Peddapalli"
    },
    {
      "state": "Telangana",
      "district": "Rajanna Sircilla"
    },
    {
      "state": "Telangana",
      "district": "Ranga Reddy"
    },
    {
      "state": "Telangana",
      "district": "Sangareddy"
    },
    {
      "state": "Telangana",
      "district": "Siddipet"
    },
    {
      "state": "Telangana",
      "district": "Suryapet"
    },
    {
      "state": "Telangana",
      "district": "Vikarabad"
    },
    {
      "state": "Telangana",
      "district": "Wanaparthy"
    },
    {
      "state": "Telangana",
      "district": "Warangal"
    },
    {
      "state": "Telangana",
      "district": "Yadadri Bhuvanagiri"
    },
    {
      "state": "Tripura",
      "district": "Dhalai"
    },
    {
      "state": "Tripura",
      "district": "Gomati"
    },
    {
      "state": "Tripura",
      "district": "Khowai"
    },
    {
      "state": "Tripura",
      "district": "North Tripura"
    },
    {
      "state": "Tripura",
      "district": "Sepahijala"
    },
    {
      "state": "Tripura",
      "district": "South Tripura"
    },
    {
      "state": "Tripura",
      "district": "Unakoti"
    },
    {
      "state": "Tripura",
      "district": "West Tripura"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Agra"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Aligarh"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Ambedkar Nagar"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Amethi"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Amroha"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Auraiya"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Ayodhya"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Azamgarh"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Bagpat"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Bahraich"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Ballia"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Balrampur"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Banda"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Barabanki"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Bareilly"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Basti"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Bhadohi"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Bijnor"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Budaun"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Bulandshahr"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Chandauli"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Chitrakoot"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Deoria"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Etah"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Etawah"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Farrukhabad"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Fatehpur"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Firozabad"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Gautam Buddha Nagar"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Ghaziabad"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Ghazipur"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Gonda"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Gorakhpur"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Hamirpur"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Hapur"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Hardoi"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Hathras"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Jalaun"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Jaunpur"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Jhansi"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Kannauj"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Kanpur Dehat"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Kanpur Nagar"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Kasganj"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Kaushambi"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Kushinagar"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Lakhimpur Kheri"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Lalitpur"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Lucknow"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Maharajganj"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Mahoba"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Mainpuri"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Mathura"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Mau"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Meerut"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Mirzapur"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Moradabad"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Muzaffarnagar"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Pilibhit"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Pratapgarh"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Prayagraj"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Raebareli"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Rampur"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Saharanpur"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Sambhal"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Sant Kabir Nagar"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Shahjahanpur"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Shamli"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Shravasti"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Siddharthnagar"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Sitapur"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Sonbhadra"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Sultanpur"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Unnao"
    },
    {
      "state": "Uttar Pradesh",
      "district": "Varanasi"
    },
    {
      "state": "Uttarakhand",
      "district": "Almora"
    },
    {
      "state": "Uttarakhand",
      "district": "Bageshwar"
    },
    {
      "state": "Uttarakhand",
      "district": "Chamoli"
    },
    {
      "state": "Uttarakhand",
      "district": "Champawat"
    },
    {
      "state": "Uttarakhand",
      "district": "Dehradun"
    },
    {
      "state": "Uttarakhand",
      "district": "Haridwar"
    },
    {
      "state": "Uttarakhand",
      "district": "Nainital"
    },
    {
      "state": "Uttarakhand",
      "district": "Pauri Garhwal"
    },
    {
      "state": "Uttarakhand",
      "district": "Pithoragarh"
    },
    {
      "state": "Uttarakhand",
      "district": "Rudraprayag"
    },
    {
      "state": "Uttarakhand",
      "district": "Tehri Garhwal"
    },
    {
      "state": "Uttarakhand",
      "district": "Udham Singh Nagar"
    },
    {
      "state": "Uttarakhand",
      "district": "Uttarkashi"
    },
    {
      "state": "West Bengal",
      "district": "Alipurduar"
    },
    {
      "state": "West Bengal",
      "district": "Bankura"
    },
    {
      "state": "West Bengal",
      "district": "Birbhum"
    },
    {
      "state": "West Bengal",
      "district": "Cooch Behar"
    },
    {
      "state": "West Bengal",
      "district": "Dakshin Dinajpur"
    },
    {
      "state": "West Bengal",
      "district": "Darjeeling"
    },
    {
      "state": "West Bengal",
      "district": "Hooghly"
    },
    {
      "state": "West Bengal",
      "district": "Howrah"
    },
    {
      "state": "West Bengal",
      "district": "Jalpaiguri"
    },
    {
      "state": "West Bengal",
      "district": "Jhargram"
    },
    {
      "state": "West Bengal",
      "district": "Kalimpong"
    },
    {
      "state": "West Bengal",
      "district": "Kolkata"
    },
    {
      "state": "West Bengal",
      "district": "Maldah"
    },
    {
      "state": "West Bengal",
      "district": "Murshidabad"
    },
    {
      "state": "West Bengal",
      "district": "Nadia"
    },
    {
      "state": "West Bengal",
      "district": "North 24 Parganas"
    },
    {
      "state": "West Bengal",
      "district": "Paschim Bardhaman"
    },
    {
      "state": "West Bengal",
      "district": "Paschim Medinipur"
    },
    {
      "state": "West Bengal",
      "district": "Purba Bardhaman"
    },
    {
      "state": "West Bengal",
      "district": "Purba Medinipur"
    },
    {
      "state": "West Bengal",
      "district": "Purulia"
    },
    {
      "state": "West Bengal",
      "district": "South 24 Parganas"
    },
    {
      "state": "West Bengal",
      "district": "Uttar Dinajpur"
    },
    {
      "state": "Andaman and Nicobar",
      "district": "Nicobar"
    },
    {
      "state": "Andaman and Nicobar",
      "district": "North and Middle Andaman"
    },
    {
      "state": "Andaman and Nicobar",
      "district": "South Andaman"
    },
    {
      "state": "Chandigarh",
      "district": "Chandigarh"
    },
    {
      "state": "Dadra and Nagar Haveli and Daman and Diu",
      "district": "Daman"
    },
    {
      "state": "Dadra and Nagar Haveli and Daman and Diu",
      "district": "Diu"
    },
    {
      "state": "Dadra and Nagar Haveli and Daman and Diu",
      "district": "Dadra and Nagar Haveli"
    },
    {
      "state": "Jammu and Kashmir",
      "district": "Anantnag"
    },
    {
      "state": "Jammu and Kashmir",
      "district": "Budgam"
    },
    {
      "state": "Jammu and Kashmir",
      "district": "Bandipore"
    },
    {
      "state": "Jammu and Kashmir",
      "district": "Baramulla"
    },
    {
      "state": "Jammu and Kashmir",
      "district": "Doda"
    },
    {
      "state": "Jammu and Kashmir",
      "district": "Ganderbal"
    },
    {
      "state": "Jammu and Kashmir",
      "district": "Jammu"
    },
    {
      "state": "Jammu and Kashmir",
      "district": "Kathua"
    },
    {
      "state": "Jammu and Kashmir",
      "district": "Kishtwar"
    },
    {
      "state": "Jammu and Kashmir",
      "district": "Kulgam"
    },
    {
      "state": "Jammu and Kashmir",
      "district": "Kupwara"
    },
    {
      "state": "Jammu and Kashmir",
      "district": "Poonch"
    },
    {
      "state": "Jammu and Kashmir",
      "district": "Pulwama"
    },
    {
      "state": "Jammu and Kashmir",
      "district": "Rajouri"
    },
    {
      "state": "Jammu and Kashmir",
      "district": "Ramban"
    },
    {
      "state": "Jammu and Kashmir",
      "district": "Reasi"
    },
    {
      "state": "Jammu and Kashmir",
      "district": "Samba"
    },
    {
      "state": "Jammu and Kashmir",
      "district": "Shopian"
    },
    {
      "state": "Jammu and Kashmir",
      "district": "Srinagar"
    },
    {
      "state": "Jammu and Kashmir",
      "district": "Udhampur"
    },
    {
      "state": "Ladakh",
      "district": "Kargil"
    },
    {
      "state": "Ladakh",
      "district": "Leh"
    },
    {
      "state": "Lakshadweep",
      "district": "Lakshadweep"
    },
    {
      "state": "Puducherry",
      "district": "Karaikal"
    },
    {
      "state": "Puducherry",
      "district": "Mahé"
    },
    {
      "state": "Puducherry",
      "district": "Puducherry"
    },
    {
      "state": "Puducherry",
      "district": "Yanam"
    }
  ];

// Helper function to get unique states
export const getUniqueStates = (): string[] => {
  return Array.from(new Set(stateDistrictData.map(item => item.state)));
};

// Helper function to get districts for a state
export const getDistrictsForState = (state: string): string[] => {
  return stateDistrictData
    .filter(item => item.state === state)
    .map(item => item.district);
}; 